export function speech(char) {
  if ('speechSynthesis' in window) {
    // Speech Synthesis supported 🎉
    var msg = new SpeechSynthesisUtterance()
    msg.text = char
    msg.lang = 'zh-CN'
    msg.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name == 'Google 普通话（中国大陆）'
    })[0]
    window.speechSynthesis.speak(msg)
  }
}

export function shuffle(arr) {
  let array = [...arr]
  var currentIndex = array.length,
    temporaryValue,
    randomIndex

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    // And swap it with the current element.
    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }

  return array
}

export function removeHtmlTags(input) {
  return input.replace(/<\/?[^>]+(>|$)/g, '')
}

export function extractUniqueChineseCharacters(input) {
  // Remove non-Chinese characters and split string into individual characters
  const characters = input.replace(/[^\u4e00-\u9fa5]/g, '').split('')

  // Convert to Set and then back to Array to remove duplicates
  const uniqueCharacters = [...new Set(characters)]

  return uniqueCharacters
}
